@if(isLayoutReady) {
<div class="form-field-wrapper">
  @if(label) {
    <label class="form-field-label"  [ngClass]="{ 'required': isRequired, 'text-dark': readonly }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
  }
  @if(translated) {
    <div class="translated-text">
        {{ translated }}
    </div>
  } @else {
    @if(!readonly) {
      <ckeditor class="editing"
      [editor]="EditEditor"
      [config]="editConfig"
      [formControl]="formControl"
      [ngClass]="{ 'has-error': errorText }"
      (ready)="onReady($event)"/>
    } @else {
      @if(!inlineEditMode) {
        <div class="field-value-inline field-value-inline__editor" (click)="inlineEditMode = editableInline ? true : false" [title]="(editableInline ? 'label.click_to_edit' : '') | translate" [ngClass]="{'field-value-inline__disabled': !editableInline}">
          @if(value || formControl.value) {
            <ckeditor class="readonly" [editor]="ViewEditor" [config]="viewConfig" [data]="value ? value : formControl.value" (ready)="onReadyView($event)" [disabled]="true" />
          } @else {
            <span class="no-data-inline-form">/</span>
          }
        </div>
      } @else {
        <ckeditor class="editing"
        [editor]="EditEditor"
        [config]="editConfig"
        [formControl]="formControl"
        [ngClass]="{ 'has-error': errorText }"
        (ready)="onReady($event)"/>
      }
    }
  }
  @if (errorText) {
    <span class="form-field-info required-label"> {{ errorText | translate }}</span>
  }
  @if (infoText && !errorText) {
    <span class="form-field-info">{{ infoText }}</span>
  }
  <app-translate-field-value *ngIf="translatable" [value]="value ? value : formControl.value" [htmlContent]="true" (onTranslate)="translate($event)"></app-translate-field-value>
</div>
}
